import { SearchFilterInput } from "@thenounproject/lingo-core";
import { createAction } from "@redux/actions/actionCreators";

const [useReplaceQueryFilters, replaceQueryFilters] = createAction<SearchFilterInput[]>(
  "search/replaceQueryFilters"
);

export default useReplaceQueryFilters;
export { replaceQueryFilters };
